import {getCurrentLayout} from "../../../../../appLayout";
import cabinetWorkspace from "./cabinetWorkspace";
import {SHAPE_PART_ID} from "../../../../constants";

class CabinetShapesLayout {

  /**
   * Create cabinets from cabinets data
   * @param data
   */
  createShapesFromCabinetSet = (data) => {
    data.positions.forEach((cabinetData) => {
      if ([SHAPE_PART_ID.lower_cabinet_boxes, SHAPE_PART_ID.upper_cabinet_boxes].includes(cabinetData.partId)) {
        const layout = getCurrentLayout();
        const feature = layout.getFeatureById(cabinetData.featureId, true);
        const parentFeature = layout.getFeatureById(cabinetData.parentFeatureId);
        const position = {x: cabinetData.x, y: cabinetData.z};
        cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature, position)
      }
    })
  }
}

export default CabinetShapesLayout;
